import * as React from 'react';

import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import Grid from '@mui/material/Grid';
import EmailIcon from '@mui/icons-material/Email';
import FeedbackIcon from '@mui/icons-material/Feedback';

// Styles
import { useTheme } from '@mui/material/styles';

import Feedback from './feedback/Feedback';
import MemberEmail from './memberemail/MemberEmail';
import WaiversList from './waivers/WaiversList';

// Auth0 user hooks 
import { useAuth0User } from '../hooks/UseAuth0User';
// Responsive hooks
import { useResponsive } from '../hooks/UseResponsive';

enum Nav {
  None = -1,
  MemberEmail = 0,
  Feedback = 1,
  Waivers = 2
}

const Admin: React.FC = () => {

  const { isEmailAdmin, isFeedbackAdmin, isMembershipAdmin, isSignupAdmin } = useAuth0User();
  const { isMobile } = useResponsive();

  const initializeActiveNav = () => {

    if (isEmailAdmin()) {
      setActiveNav(Nav.MemberEmail);
    }
    if (isFeedbackAdmin()) {
      setActiveNav(Nav.Feedback);
    }
    if (isSignupAdmin() || isMembershipAdmin()) {
      setActiveNav(Nav.Waivers);
    }
  }

  const [activeNav, setActiveNav] = React.useState<Nav>(Nav.None);

  // #region Styles

  const theme = useTheme();
  const styles = {
    contentContainer: {
      width: '100%'
    },
    navContainer: {
      width: '100%'
    },
    nav: {
      borderBottom: `1px solid ${theme.palette.divider}`,
      flexGrow: 1,
      margin: theme.spacing(1, 0, 1, 0)
    },
  };

  // #endregion

  // #region Event Handlers

  const handleNavChange = (event: React.ChangeEvent<{}>, index: number) => {
    setActiveNav(index);
  };

  React.useEffect(() => {
    initializeActiveNav();;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // #endregion

  return (
    <>
      <Grid container sx={styles.navContainer}>
        <BottomNavigation
          value={activeNav}
          onChange={handleNavChange}
          showLabels
          sx={styles.nav}
        >
          {(!isMobile && isEmailAdmin()) &&
            <BottomNavigationAction label="Member Email" icon={<EmailIcon />} />
          }
          {(!isMobile && isFeedbackAdmin()) &&
            <BottomNavigationAction label="Feedback" icon={<FeedbackIcon />} />
          }
          {(isSignupAdmin() || isMembershipAdmin()) &&
            <BottomNavigationAction label="Waivers" icon={<FeedbackIcon />} />
          }
        </BottomNavigation>
      </Grid >
      <Grid container sx={styles.contentContainer}>
        {activeNav === Nav.MemberEmail &&
          <MemberEmail />
        }
        {activeNav === Nav.Feedback &&
          <Feedback />
        }
        {activeNav === Nav.Waivers &&
          <WaiversList />
        }
      </Grid >
    </>
  );
}

export default Admin;
